import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { openPopup, closePopup, clearPopup } from '../actions/popup';
import { openSnackbar, closeSnackbar } from '../actions/snackbar';
import { checkSession, getCurrentUserData } from '../actions/user';

import UserRestorePassword from './UserRestorePassword';
import UserRegister from './UserRegister';
import { setCookie } from '../lib/cookies';

function UserLogin({ openPopup, closePopup, openSnackbar, closeSnackbar, checkSession, getCurrentUserData }) {

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const login = (e) => {
    e.preventDefault();
    document.getElementById('iframeAuth').contentWindow.postMessage(JSON.stringify({username, password}), "*")
  }
  const register = (e) => {
    e.preventDefault();
    openPopup('Регистрация', <UserRegister />)
  }

  const forgotPassword = e => {
    e.preventDefault();
    openPopup('Восстановить пароль', <UserRestorePassword />);
  }

  useEffect(() => {
    return () => {
      window.removeEventListener('message', message, false)
    }
  }, [])

  const onload = () => {
    window.addEventListener('message', message, false)
  }

  const message = (e) => {
    if (e.origin === `https://hcvf.citorus.ru:8889`) {
      const data = JSON.parse(e.data)
      if (data.error === true) {
        openSnackbar(data.msg, "error")
        return;
      } else if (data.error === false) {
        const uid = data.msg
        setCookie("uid", uid)
        checkSession(uid)
        // closePopup()
      }
    }
  }

  return (
    <form className='auth-loginForm'>
      <iframe id="iframeAuth" onLoad={onload} name="iframeAuth" src="https://hcvf.citorus.ru:8889/public/hcvf_auth/" style={{position: 'absolute', width: 0, height: 0, border: 'none'}}></iframe>
      <input className="auth-input small" onChange={e => setUsername(e.target.value)} autoComplete='off' type="text" placeholder="Логин" />
      <input className="auth-input small" onChange={e => setPassword(e.target.value)} autoComplete='off' style={{ margin: '12px 0' }} type="password" placeholder="Пароль" />

      <div className='auth-loginForm links'>
        <span onClick={register}>Регистрация</span>
        <span onClick={forgotPassword} style={{ marginLeft: '12px' }}>Забыли пароль</span>
      </div>

      <button onClick={login} className="auth-button mt-24">Войти</button>
    </form>
  )
}
export default connect(null, { openPopup, closePopup, openSnackbar, closeSnackbar, checkSession, getCurrentUserData })(UserLogin)